import { Component, OnInit } from '@angular/core';
import { PubSubService } from './core/services/pub-sub-service/pub-sub.service';
import * as introJs from 'intro.js/intro.js';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'BoomCaster';
  isLoader: boolean = false;
  constructor(
    private pubSubService: PubSubService) { }

  ngOnInit(): void {
    this.pubSubService.getloader.subscribe((isLoader: boolean) => {
      setTimeout(() => {
        this.isLoader = isLoader;
      }, 2e2)
    });
    this.introJS.start();
  }
  introJS = introJs();
}

